<template>
  <section class="so">
    <div class="so-header">
      <div class="so-title-line1">{{ $t('homeNew.startOffers.titleLine1') }}</div>
      <div class="so-title-line2">{{ $t('homeNew.startOffers.titleLine2') }}</div>
    </div>

    <div class="so-cards">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="so-card"
      >
        <h3 class="so-card-heading">{{ $t('homeNew.startOffers.cards.' + index + '.heading') }}</h3>
        <div class="so-price">
          <span class="so-price-value">{{ $t('homeNew.startOffers.cards.' + index + '.price') }}</span><span class="so-price-currency">€</span>
        </div>
        <p
          class="so-description"
          v-html="$t('homeNew.startOffers.cards.' + index + '.description')"
        />
        <div class="so-actions">
          <button
            type="button"
            class="so-button so-button--learn"
            @click="openModal(index)"
          >
            {{ $t('homeNew.startOffers.learnMore') }}
          </button>
          <router-link
            :to="state.authorized ? '/dashboard#contract' : '/pricing'"
            class="so-button so-button--buy"
          >
            {{ $t('homeNew.startOffers.buyNow') }}
          </router-link>
        </div>
      </div>
    </div>

    <ModalWindow
      v-if="activeModal !== null"
      :title="$t('homeNew.startOffers.cards.' + activeModal + '.heading')"
      subtitle=""
      @closeModal="closeModal"
    >
      <p class="so-modal-text">{{ $t('homeNew.startOffers.cards.' + activeModal + '.modalText') }}</p>
      <button
        type="button"
        class="so-button so-button--learn so-modal-ok"
        @click="closeModal"
      >
        {{ $t('homeNew.startOffers.modalOk') }}
      </button>
    </ModalWindow>
  </section>
</template>

<script>
import ModalWindow from '@/components/ModalWindow.vue';
import { state } from '@/state';

export default {
  name: 'MainStartOffers',
  components: {
    ModalWindow,
  },
  data() {
    return {
      state,
      cards: [0, 1],
      activeModal: null,
    };
  },
  methods: {
    openModal(index) {
      this.activeModal = index;
      document.body.classList.add('menu-open');
    },
    closeModal() {
      this.activeModal = null;
      document.body.classList.remove('menu-open');
    },
  },
};
</script>

<style scoped>
.so {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;
}

@media screen and (min-width: 768px) {
  .so {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 32px;
  }
}

@media screen and (min-width: 1024px) {
  .so {
    padding-left: 60px;
    padding-right: 60px;
    padding-bottom: 40px;
  }
}

@media screen and (min-width: 1440px) {
  .so {
    padding-left: 80px;
    padding-right: 80px;
    padding-bottom: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .so {
    padding-left: 120px;
    padding-right: 120px;
  }
}

.so-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 28px 0;
  text-align: center;
}

@media screen and (min-width: 768px) {
  .so-header {
    padding: 32px 0;
  }
}

@media screen and (min-width: 1280px) {
  .so-header {
    padding: 40px 0;
  }
}

.so-title-line1 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 32px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 768px) {
  .so-title-line1 {
    font-size: 40px;
  }
}

@media screen and (min-width: 1280px) {
  .so-title-line1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1920px) {
  .so-title-line1 {
    font-size: 54px;
  }
}

.so-title-line2 {
  white-space: pre-line;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 768px) {
  .so-title-line2 {
    font-size: 20px;
  }
}

@media screen and (min-width: 1280px) {
  .so-title-line2 {
    font-size: 24px;
  }
}

.so-cards {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media screen and (min-width: 768px) {
  .so-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 40px;
  }

  .so-card {
    height: 100%;
    min-height: 100%;
    border: 1px solid #000;
    border-radius: 24px;
    box-sizing: border-box;
    padding: 24px 16px;
  }
}

@media screen and (min-width: 1420px) {
  .so-cards {
    width: 1320px;
    max-width: 1320px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (min-width: 1620px) {
  .so-cards {
    width: 1520px;
    max-width: 1520px;
    margin-left: auto;
    margin-right: auto;
  }
}

.so-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 0;
}

.so-card-heading {
  margin: 0;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 32px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 1024px) {
  .so-card-heading {
    font-size: 40px;
  }
}

@media screen and (min-width: 1280px) {
  .so-card-heading {
    font-size: 48px;
  }
}

@media screen and (min-width: 1920px) {
  .so-card-heading {
    font-size: 54px;
  }
}

.so-price {
  margin-top: 16px;
  line-height: 1;
  color: #000;
}

.so-price-value {
  font-weight: 400;
  font-size: 30px;
}

.so-price-currency {
  font-weight: 400;
  font-size: 24px;
}

@media screen and (min-width: 1024px) {
  .so-price-value {
    font-size: 38px;
  }

  .so-price-currency {
    font-size: 32px;
  }
}

@media screen and (min-width: 1280px) {
  .so-price-value {
    font-size: 46px;
  }

  .so-price-currency {
    font-size: 40px;
  }
}

@media screen and (min-width: 1920px) {
  .so-price-value {
    font-size: 52px;
  }

  .so-price-currency {
    font-size: 48px;
  }
}

.so-description {
  margin: 16px 0 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 22px;
  color: #8a8a8a;
  white-space: pre-line;
}

@media screen and (min-width: 1024px) {
  .so-description {
    font-size: 28px;
  }
}

.so-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 24px;
}

@media screen and (min-width: 768px) {
  .so-description {
    flex: 1;
  }

  .so-actions {
    margin-top: auto;
    padding-top: 24px;
    width: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .so-actions {
    gap: 32px;
  }
}

@media screen and (min-width: 1280px) {
  .so-actions {
    gap: 40px;
  }
}

.so-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 152px;
  height: 44px;
  border-radius: 22px;
  font-size: 20px;
  font-weight: 400;
  line-height: 1;
  color: #fff;
  text-decoration: none;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  .so-button {
    width: 180px;
    font-size: 24px;
  }
}

.so-button--learn {
  background: #000;
}

.so-button--buy {
  background: #b5261e;
}

.so-modal-text {
  margin: 24px 0 0;
  white-space: pre-line;
  line-height: 1.5;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}

:deep(.heading) {
  text-transform: uppercase;
  margin-bottom: 0;
}

:deep(.modal-buttons) {
  justify-content: flex-end;
  margin-bottom: 0;
  padding-bottom: 0;
}

@media screen and (min-width: 768px) {
  .so-modal-text {
    font-size: 18px;
  }
}

.so-modal-ok {
  display: flex;
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;
}
</style>
